import { createContext, useContext } from 'react'

const AuthContext = createContext({
  user: null,
  app: null,
  token: null,
})

export { AuthContext }

export function useAuth() {
  return useContext(AuthContext)
}
